"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultCountryFields = exports.CountryFields = void 0;
var _Input = _interopRequireDefault(require("../fields/Input"));
var _fields = require("../fields");
var _nativePaymentPropsGenerator = require("../../utils/native-payment/nativePaymentPropsGenerator");
var _fieldsMessages = require("../fields/fieldsMessages");
var _commonUtils = require("../../utils/commonUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* Listed the countries and fields according to listed countries will be visible in Billing Address Container. 
  Add the country and fields in CountryFields object to show respective fields in Billing Adress container.
 */
var defaultCountryFields = getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode']);

/* 
If any field is optional to any country, add ":optional" to the filed name.
example :- 
        addressLineTwo field is optional for the countries  US,CA,GB and other countries, 
        so adding the field name to the array is like 'addressLineTwo:optional'.

     if state field and addressLineTwo fields are optional to DE country, then follow like 

     DE: getCountryFields(["addressLine",'addressLineTwo:optional', 'city','state:optional','zipCode'],"de")

*/
exports.defaultCountryFields = defaultCountryFields;
var CountryFields = {
  US: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "us"),
  CA: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "ca"),
  GB: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "gb"),
  DE: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "de"),
  NL: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "nl"),
  MX: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "mx"),
  SE: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "se"),
  AU: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "au"),
  FR: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "fr"),
  BR: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "br"),
  IT: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "it"),
  IE: getCountryFields(["addressLine", 'addressLineTwo:optional', 'city', 'state', 'zipCode'], "ie"),
  JP: getCountryFields(["zipCode", 'state', 'city', "addressLine", 'addressLineTwo:optional'], "jp")
};
exports.CountryFields = CountryFields;
function getCountryFields() {
  var reqFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var country = arguments.length > 1 ? arguments[1] : undefined;
  var fieldsObj = {
    addressLine: {
      field: _Input.default,
      fieldProps: (0, _nativePaymentPropsGenerator.getAddressLineProps)(country && (0, _commonUtils.getRequiredPropsObj)(_fieldsMessages.addressLinePropsObj, country)),
      name: 'addressLine'
    },
    addressLineTwo: {
      field: _Input.default,
      fieldProps: (0, _nativePaymentPropsGenerator.getAddressLineTwoProps)(country && (0, _commonUtils.getRequiredPropsObj)(_fieldsMessages.addressLineTwoPropsObj, country)),
      optional: true,
      name: 'addressLineTwo'
    },
    city: {
      field: _Input.default,
      fieldProps: (0, _nativePaymentPropsGenerator.getCityProps)(country && (0, _commonUtils.getRequiredPropsObj)(_fieldsMessages.getCityPropsObj, country)),
      name: 'city'
    },
    state: {
      field: _fields.State,
      fieldProps: (0, _nativePaymentPropsGenerator.getStateProps)(country && (0, _commonUtils.getRequiredPropsObj)(_fieldsMessages.getStatePropsObj, country)),
      isState: true,
      name: 'state'
    },
    zipCode: {
      field: _Input.default,
      fieldProps: (0, _nativePaymentPropsGenerator.getZipCodeProps)(country && (0, _commonUtils.getRequiredPropsObj)(_fieldsMessages.getZipCodePropsObj, country)),
      name: 'zipCode'
    }
  };
  var fieldsArr = reqFormat.map(function (ele) {
    ele = ele.split(":");
    var fieldName = ele[0],
      optional = ele[1],
      fieldObj = fieldsObj[fieldName];

    /*  setting the field is optional field or mandatory field  */

    fieldObj.optional = optional == "optional" ? true : false;
    return fieldObj;
  });
  return fieldsArr;
}